export default "__VITE_ASSET__BIeD8OGo__"